const items = document.querySelectorAll(".carousel-tab-content");
const sections = document.querySelectorAll(".carousel-how-to-row ");
const navbar = document.getElementById("myTabHowTo");
const itemsLength = items.length;
let activeNavItem = 0;

const removeDnone = () => {
  for (var i = 0; i < sections.length; i++) {
    sections[i].classList.remove("d-none");
  }
};

const createNavBarItems = () => {
  for (var i = 0; i < itemsLength; i++) {
    const li = document.createElement("li");
    li.classList.add("nav-item");
    li.classList.add("nav-item-how-to");
    li.setAttribute("role", "presentation");
    if (i === 0) {
      li.classList.add("active");
    }
    navbar.appendChild(li);
    const a = document.createElement("a");
    const tabContent = items[i].id;
    a.classList.add("fs-3");
    a.classList.add("nav-link");
    a.classList.add("nav-link-how-to");
    a.setAttribute("href", "#" + tabContent);
    a.setAttribute("index", i.toString());
    a.textContent = tabContent;
    a.addEventListener("click", function handleClick(event) {
      const navItems = document.querySelectorAll(".nav-item-how-to");
      navItems[activeNavItem].classList.remove("active");
      const num = event.target.getAttribute("index");
      activeNavItem = Number(num);
      navItems[activeNavItem].classList.add("active");
    });
    li.appendChild(a);
  }
};

createNavBarItems();

function activateMobileFunction(x) {
  if (x.matches) {
    removeDnone();
  }
}

var x = window.matchMedia("(max-width: 700px)");
activateMobileFunction(x);
x.addEventListener("change", activateMobileFunction);
